import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Col, Datepicker, Label, Row } from '@folio/stripes-components';
import { required } from '../../../utils/utils';
import HelpeModal from '../../HelpeModal';
import css from '../styles.css';

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  locale: PropTypes.string,
  showHelpeIcon: PropTypes.bool,
  fieldName: PropTypes.string,
};

function DateFieldComponent({
  fieldValues,
  index,
  locale,
  showHelpeIcon,
  fieldName,
}) {
  const { name, label, type, isRequired, canEdit, defaultValue, helpeText } =
    fieldValues;
  const fieldLabel = label.find((field) => field.locale === locale)?.value;

  return (
    <Row>
      <Col xs={showHelpeIcon ? 11 : 12}>
        <Field
          id={`inventory-templates-form-generator-${type}-field-${index}`}
          component={Datepicker}
          fullWidth
          name={fieldName}
          // subscription={{ value: true }}
          label={<Label fullWidth>{fieldLabel}</Label>}
          required={isRequired}
          validate={isRequired ? required : undefined}
          type="text"
          disabled={!canEdit}
          dateFormat="YYYY/MM/DD"
          backendDateStandard="YYYY/MM/DD"
          // defaultValue={new Date()}
          parse={(value) => (value === '' ? null : value)} // Fix issue: Empty values don't appear in values
        />
      </Col>
      {showHelpeIcon && (
        <Col xs={1} className={css.margin_btn}>
          <HelpeModal
            fieldData={fieldValues}
            title={fieldLabel}
            iconSize="medium"
          />
        </Col>
      )}
    </Row>
  );
}

DateFieldComponent.propTypes = propTypes;

export default DateFieldComponent;
